import { AuthStateType } from "../../UserReducer"
import { ActionType } from "../../Actions"
import { DEVICE_CODE } from "../../Actions/Auth/deviceCodeAction";

export default function deviceCodeReducer (state: AuthStateType, action: ActionType): AuthStateType {

    if (action?.type === DEVICE_CODE){
        return {
            ...state,
            deviceCodeResult: action.payload
        }
    }

    return state;
}